import { FlaskConical, ShieldCheck, Shield, User, Stethoscope, Languages, ArrowLeft } from "lucide-react";
import { toast } from "sonner";
import { apiErr } from "../lib/api";
import { switchToTestRole, returnFromTestRole, activeTestRole } from "../lib/testRole";

const ROLES = [
  { key: "super_admin", label: "Super Administrator", desc: "Full management: content, appointments, users, clinics, banners, settings — no role reassignment.", icon: ShieldCheck },
  { key: "admin", label: "Administrator", desc: "Content, inventory, schedules, events, appointments & Q&A. No governance tabs.", icon: Shield },
  { key: "clinical_specialist", label: "Clinician Account", desc: "Clinical Specialist view: dashboard, appointments, content and Q&A. No governance or user management.", icon: Stethoscope },
  { key: "language_interpreter", label: "Language Interpreter", desc: "Interpreter portal: availability, assignments and joining consultations as an interpreter.", icon: Languages },
  { key: "basic", label: "Basic User", desc: "The patient portal experience (appointments, feedback, alerts).", icon: User },
];

export function AdminTestRoles() {
  const go = async (r) => {
    try { await switchToTestRole(r); }
    catch (e) { toast.error(apiErr(e)); }
  };
  return (
    <div data-testid="test-roles-panel">
      <h1 className="font-heading font-bold text-3xl tracking-tight text-ink flex items-center gap-2">
        <FlaskConical className="w-7 h-7 text-clinical" /> Test Roles
      </h1>
      <p className="text-muted2 text-sm mt-2 max-w-2xl">
        Switch into a seeded test account to validate exactly what each role can access. A banner will let you
        return to your own System Administrator account at any time.
      </p>
      <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4 mt-6">
        {ROLES.map((r) => (
          <button
            key={r.key}
            data-testid={`test-role-${r.key}`}
            onClick={() => go(r.key)}
            className="text-left bg-white border border-line rounded-xl p-5 hover:border-clinical hover:shadow-sm transition-all"
          >
            <r.icon className="w-7 h-7 text-clinical" />
            <p className="font-heading font-bold text-ink mt-3">{r.label}</p>
            <p className="text-sm text-muted2 mt-1">{r.desc}</p>
            <span className="inline-block mt-4 text-sm font-semibold text-clinical">Test as this role →</span>
          </button>
        ))}
      </div>
    </div>
  );
}

const LABELS = { super_admin: "Super Administrator", admin: "Administrator", clinical_specialist: "Clinician Account", language_interpreter: "Language Interpreter", public: "Basic User" };

export function TestRoleBanner() {
  const role = activeTestRole();
  if (!role) return null;
  return (
    <div data-testid="test-role-banner" className="fixed bottom-4 left-1/2 -translate-x-1/2 z-[70] bg-ink text-white rounded-full shadow-xl px-4 py-2 flex items-center gap-3 text-sm">
      <span className="flex items-center gap-1.5"><FlaskConical className="w-4 h-4 text-alert" /> Testing as <b>{LABELS[role] || role}</b></span>
      <button onClick={returnFromTestRole} data-testid="return-from-test-role" className="inline-flex items-center gap-1 bg-white text-ink font-semibold rounded-full px-3 py-1">
        <ArrowLeft className="w-3.5 h-3.5" /> Return to my account
      </button>
    </div>
  );
}
